<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import MainFilterSelect from '../PaymentsMainFilterSelect';
import SupplierFilterSelect from './SupplierPaymentsSupplierFilterSelect';

export default {
  name: 'MainFilters',
  components: {
    MainFilterSelect,
    SupplierFilterSelect,
  },
  computed: {
    ...mapState({
      selectedProductTypes: state => state.supplierPayments.filter.data.selectedProductTypes,
      selectedBrands: state => state.supplierPayments.filter.data.selectedBrands,
      selectedDomains: state => state.supplierPayments.filter.data.selectedDomains,
      selectedSuppliers: state => state.supplierPayments.filter.data.selectedSuppliers,
      hideZeroSuppliers: state => state.supplierPayments.filter.data.hideZeroSuppliers,
      productTypes: state => state.supplierPayments.filter.data.productTypes,
      brands: state => state.supplierPayments.filter.data.brands,
      filterLoading: state => state.supplierPayments.filter.data.loading,
      filterError: state => state.supplierPayments.filter.data.error,
      loading: state => state.supplierPayments.tableData.loading,
    }),
    ...mapGetters({
      suppliers: 'supplierPayments/getSuppliersForFilter',
      domains: 'supplierPayments/getDomainsForFilter',
    }),
    disabled() {
      return this.filterLoading || this.filterError || this.loading;
    },
  },
  methods: {
    ...mapActions({
      updateProductTypes: 'supplierPayments/updateSelectedProductTypes',
      updateBrand: 'supplierPayments/updateSelectedBrands',
      updateSuppliers: 'supplierPayments/updateSelectedSuppliers',
      updateDomains: 'supplierPayments/updateSelectedDomains',
      updateSupplierSearch: 'supplierPayments/updateSupplierSearch',
      updateHideZeroSuppliers: 'supplierPayments/updateHideZeroSuppliers',
    }),
  },
};
</script>

<template>
  <v-container class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 mr-4>
        <main-filter-select
          :availableItems="brands"
          :selectedItems="selectedBrands"
          :updateItems="updateBrand"
          :label="$t('payments.filters.brands')"
          :disabled="disabled"
        />
      </v-flex>
      <v-flex xs12 ml-4>
        <main-filter-select
          :availableItems="domains"
          :selectedItems="selectedDomains"
          :updateItems="updateDomains"
          :label="$t('payments.filters.domains')"
          :disabled="disabled"
        />
      </v-flex>
    </v-layout>
      <v-layout row>
        <v-flex xs6 mr-4>
          <main-filter-select
            :availableItems="productTypes"
            :selectedItems="selectedProductTypes"
            :updateItems="updateProductTypes"
            :label="$t('payments.filters.productTypes')"
            :disabled="disabled"
          />
        </v-flex>
        <v-flex xs6 ml-4>
          <supplier-filter-select
            :availableItems="suppliers"
            :selectedItems="selectedSuppliers"
            :updateItems="updateSuppliers"
            :label="$t('payments.filters.suppliers')"
            :disabled="disabled"
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-switch
            :input-value="hideZeroSuppliers"
            @change="updateHideZeroSuppliers(!!$event)"
            :label="$t('payments.filters.hideZeroSuppliers')"
            color="primary"
            hide-details
          />
        </v-flex>
      </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/payments/supplier-payments/SupplierPaymentsMainFilters.vue